import React from 'react';
import App from 'index/App';
import AuthProvider from './index/AuthProvider';

const Application = props => (
  <AuthProvider>
    <App {...props} />
  </AuthProvider>
);

export default Application;
